import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Session} from "./Session";

@Injectable({
  providedIn: 'root'
})
export class WallDashBoardActivator implements CanActivate {
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {
        const activeApps = Session.get('activeApps') || [];
        if (activeApps.length != 0 && activeApps.indexOf('wall') != -1 && Session.hasSession()){
            this.router.navigate(['']);
            return false;
        }
        return true;
    }
    constructor(private router: Router) {}
}
